const COPY: Record<string, { title: string; body: string }> = {
  not_found: { title: 'Campanha não encontrada', body: 'Este link pode estar incorreto.' },
  unavailable: { title: 'Campanha indisponível', body: 'Esta campanha não está ativa no momento.' },
  error: { title: 'Ops', body: 'Algo deu errado.' },
}

export function NotAvailable({
  reason,
  message,
  onRetry,
}: {
  reason: 'not_found' | 'unavailable' | 'error'
  message?: string
  onRetry?: () => void
}) {
  const copy = COPY[reason]
  return (
    <div
      className="flex min-h-0 flex-1 flex-col items-center justify-center px-6 text-center"
      style={{ background: 'var(--scr)' }}>
      <div className="max-w-sm">
        <h1 className="t-title mb-2" style={{ color: 'var(--txt)' }}>{copy.title}</h1>
        <p className="t-body" style={{ color: 'var(--txt2)' }}>{message ?? copy.body}</p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="mt-6 rounded-[14px] px-6 py-3 text-[1.0625rem] font-bold text-surface-raised bg-accent transition active:scale-[0.99]">
            Tentar novamente
          </button>
        )}
      </div>
    </div>
  )
}
